// Framework and third-party non-ui
import React, { useContext, useState } from "react";
import { Route } from "react-router-dom";

// App components
import { MapContext } from "contexts/MapContext";
import {
  TrailDetails,
  PoiDetails,
  ProfileDetails,
  TripHistoryDetails,
  TrailheadDetails,
} from "components/TrailCard";
import { FeaturedRouteDetails } from "components/FeaturedRoute";
import Options from "./Options";
// JSON & Styles
import { StyledSidebar, StyledLoader } from "./Sidebar-styled";

// Third-party components (buttons, icons, etc.)
import {
  FavoritedTrailsList,
  TripsList,
  FeaturedList,
} from "components/TrailsList";
import TrailsList from "components/TrailsList";

const Sidebar = () => {
  const {
    ready,
    setSidebarSelection,
    sidebarSelection,
    mapView,
    extentHistory,
    setExtentHistory,
    resetCardsToPrevious,
  } = useContext(MapContext);
  const [clickedOption, setClickedOption] = useState("Trails");

  const getLoadingIndicator = () => {
    return <StyledLoader sizeRatio={1.5} text="Loading..." />;
  };

  if (!ready) {
    return getLoadingIndicator();
  }

  const getComponent = () => {
    if (sidebarSelection) {
      if (sidebarSelection[0] === "Trail") {
        return (
          <TrailDetails
            attributes={sidebarSelection[1]}
            setSidebarSelection={setSidebarSelection}
            nearbyTrails={sidebarSelection[2] ? sidebarSelection[2] : null}
            onReturnToDetails={async () => {
              if (extentHistory) {
                await mapView.goTo(extentHistory);
                setExtentHistory(null);
                resetCardsToPrevious();
              }
            }}
          />
        );
      } else if (sidebarSelection[0] === "POI") {
        return (
          <PoiDetails
            attributes={sidebarSelection[1]}
            setSidebarSelection={setSidebarSelection}
          />
        );
      } else if (sidebarSelection[0] === "Trailhead POI") {
        return <TrailheadDetails feature={sidebarSelection[1]} />;
      } else if (sidebarSelection[0] === "Profile") {
        return <ProfileDetails />;
      } else if (sidebarSelection[0] === "Favorites") {
        return <FavoritedTrailsList />;
      } else if (sidebarSelection[0] === "Recorded Trips") {
        return <TripsList />;
      } else if (sidebarSelection[0] === "Recorded Trip Details") {
        return (
          <TripHistoryDetails
            feature={sidebarSelection[1]}
            attributes={sidebarSelection[2]}
            setSidebarSelection={setSidebarSelection}
            nearbyTrails={sidebarSelection[3] ? sidebarSelection[3] : null}
          />
        );
      } else if (sidebarSelection[0] === "Featured Route") {
        return (
          <FeaturedRouteDetails
            attributes={sidebarSelection[1]}
            setSidebarSelection={setSidebarSelection}
            nearbyTrails={sidebarSelection[2] ? sidebarSelection[2] : null}
          />
        );
      }
    }
    if (clickedOption === "Featured") {
      return <FeaturedList />;
    } else if (clickedOption === "Trails") {
      return <TrailsList />;
    }
  };
  return (
    <StyledSidebar data-testid="Sidebar">
      <Route path="/details">
        {!sidebarSelection ? (
          <Options
            setClickedOption={setClickedOption}
            clickedOption={clickedOption}
          />
        ) : null}
        {getComponent()}
      </Route>
    </StyledSidebar>
  );
};

export default Sidebar;
